import React from 'react';

import {keys} from 'lodash/object';
import {FormGroup, CustomInput, FormFeedback, Label} from 'reactstrap';

import {REGEXP_FEEDBACK} from 'configs';
import {CB_ENQUIRY_TYPE} from 'configs/types';
import {SelectPublicCECB, SelectBranch} from 'components/Forms/Selects';
import PublicContact from 'components/Publics/PublicContactNew';

import useSendCBEnquiry from './useSendCBEnquiry';

import styles from './styles.module.scss';

const defaultProps = {
  showSubmit: true,
};

const CBContact = (props) => {
  const {cbId, ceId} = props;

  const {validation, handleChangeCB, selectedCBId} = useSendCBEnquiry(cbId);

  return (
    <section>
      <h3 className={styles['section__title']}>Contact us</h3>
      <PublicContact
        companyType="cb"
        companyId={selectedCBId}
        description="Get in touch with this Certification Body"
        validation={validation}
        callback={() => handleChangeCB({certification_bodies_id: cbId})} // revert to default value of select
      >
        {!cbId && (
          <FormGroup>
            <Label>Select Certification Body</Label>

            <SelectPublicCECB ceId={ceId} onChange={handleChangeCB} required />
            <FormFeedback>{REGEXP_FEEDBACK.required}</FormFeedback>
          </FormGroup>
        )}

        <FormGroup>
          <Label>Select Branch</Label>

          <SelectBranch
            isDisabled={!selectedCBId}
            key={selectedCBId}
            id={selectedCBId}
            companyType="cb"
            name="enquires_recv_company_id"
            required
          />
          <FormFeedback>{REGEXP_FEEDBACK.required}</FormFeedback>
        </FormGroup>

        <FormGroup>
          <Label>Enquiry Category</Label>

          <CustomInput
            id="enquiry_category"
            type="select"
            name="enquires_category"
            required
          >
            {keys(CB_ENQUIRY_TYPE).map((key, index) => (
              <option key={index} value={key}>
                {CB_ENQUIRY_TYPE[key]}
              </option>
            ))}
          </CustomInput>
          <FormFeedback>{REGEXP_FEEDBACK.required}</FormFeedback>
        </FormGroup>
      </PublicContact>
    </section>
  );
};

CBContact.defaultProps = defaultProps;

export default CBContact;
